export const ISSUE_STATUS = {
  REGISTERED: 'REGISTERED',
  RECEIVED: 'RECEIVED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
  REJECTED: 'REJECTED'
};

export const ISSUE_STATUS_OPTIONS = [
  { name: '등록', value: ISSUE_STATUS.REGISTERED },
  { name: '접수', value: ISSUE_STATUS.RECEIVED },
  { name: '처리중', value: ISSUE_STATUS.IN_PROGRESS },
  { name: '완료', value: ISSUE_STATUS.COMPLETED },
  { name: '취소', value: ISSUE_STATUS.CANCELLED },
  { name: '거절', value: ISSUE_STATUS.REJECTED }
];

export const ISSUE_STATUS_SEVERITY = {
  [ISSUE_STATUS.REGISTERED]: 'info',
  [ISSUE_STATUS.RECEIVED]: 'warning',
  [ISSUE_STATUS.IN_PROGRESS]: 'warning',
  [ISSUE_STATUS.COMPLETED]: 'success',
  [ISSUE_STATUS.CANCELLED]: 'danger',
  [ISSUE_STATUS.REJECTED]: 'danger'
}; 